// ProductCategory.js

import { Navigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SEO from "../../02-molecules/SEO/SEO";
import Breadcrumb from "../../01-atoms/breadcrumbs/Breadcrumbs";
import SortProducts from "../../02-molecules/sortProducts/SortProducts";

const ProductCategory = (props) => {
    const { productCategoryArray, productAssetArray, handleLoading } = props;
    const { categoryTitle } = useParams();

    // replaced '-' with space to match it with product name below
    const categoryTitleFormatted = categoryTitle.replace(/-/g, ' ');

    // Filter product category based on the selected category
    const selectedProductCategory = productCategoryArray.filter(
        (product) => product.fields.name.toLowerCase() === categoryTitleFormatted.toLowerCase()
    );

    // Filter products based on the selected category
    const selectedProducts = productAssetArray.filter(
        (product) => product.product.fields.productCategory.toLowerCase() === categoryTitleFormatted.toLowerCase()
    );

    // If the selected product category is empty, navigate to the 404 page
    if (selectedProductCategory.length === 0) {
        return <Navigate to="/404" />;
    }

    return(
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <Breadcrumb />

                <SEO
                    title={`Buy Modern ${selectedProductCategory[0].fields.name} Online | Ajit Furniture House`}
                    description={selectedProductCategory[0].fields.description}
                    name=''
                    type='product'
                />
                
                <div className="content-container">
                    <div className="products-category">
                        <div className="products-category__description">
                            <h2>{selectedProductCategory[0].fields.name.toUpperCase()}</h2>
                            <p>{selectedProductCategory[0].fields.description}</p>
                        </div>
                        
                        <SortProducts selectedProducts={selectedProducts} handleLoading={handleLoading}/>
                        {/* <div className="products-category__total">
                            Total Results - {selectedProducts.length}
                        </div> */}
                    </div>
                </div>
            </div>
        </main>
    )
}

export default ProductCategory;